function updateScrollspyNav(event, scrollspyNav) {

  if (!event) {
    scrollspyNav.style.setProperty('--scrollspy-item-height', '0px');

  } else {
    const scrollSpyNavTopPosition = scrollspyNav.getBoundingClientRect().y,
      itemTopPosition = event.relatedTarget.getBoundingClientRect().y,
      itemHeight = event.relatedTarget.getBoundingClientRect().height,
      realTopPosition = itemTopPosition - scrollSpyNavTopPosition;

    scrollspyNav.style.setProperty('--scrollspy-item-top', `${realTopPosition}px`);
    scrollspyNav.style.setProperty('--scrollspy-item-height', `${itemHeight}px`);
  }
}

export function initScrollspy(ScrollSpy) {
  const scrollspyElement = document.querySelector('.content'),
    scrollspyNav = document.querySelector('.table-of-content-nav');

  if(!scrollspyElement || !scrollspyNav) return;

  new ScrollSpy(scrollspyElement, {target: scrollspyNav});

  scrollspyElement.addEventListener('activate.bs.scrollspy', e => {
    updateScrollspyNav(e, scrollspyNav);
  })

  window.addEventListener('scroll', () => {
    const activeScrollspyNavItem = document.querySelector('.table-of-content-link.active') ?? false;
    if (!activeScrollspyNavItem) updateScrollspyNav(false, scrollspyNav);
  })
}
